import PropTypes from "prop-types";
import { IconButton, useTheme } from "@mui/material";
import BookmarkIcon from "./bookmark-icon";
import useBookmarkToggle from "./use-bookmark-toggle";

const SIZE_CONFIG = {
  compact: { iconPixels: 16, buttonSize: 32, padding: 0.5 },
  default: { iconPixels: 20, buttonSize: 40, padding: 1 },
  large: { iconPixels: 22, buttonSize: 44, padding: 1 },
};

export const Bookmark = ({
  size = "default",
  hasBackground = false,
  ...bookmark
}) => {
  const theme = useTheme();
  const { checked, updating, handleToggle, label } = useBookmarkToggle(bookmark);
  const sizeConfig = SIZE_CONFIG[size] ?? SIZE_CONFIG.default;

  return (
    <IconButton
      data-testid="bookmark-toggle"
      aria-label={label}
      aria-pressed={checked}
      onClick={handleToggle}
      disabled={updating}
      sx={{
        p: sizeConfig.padding,
        width: sizeConfig.buttonSize,
        height: sizeConfig.buttonSize,
        visibility: checked ? "visible" : "inherit",
        "&:hover, &.Mui-focusVisible": {
          backgroundColor: hasBackground
            ? theme.palette.background.paper
            : "transparent",
        },
      }}
    >
      <BookmarkIcon checked={checked} iconPixels={sizeConfig.iconPixels} />
    </IconButton>
  );
};

Bookmark.propTypes = {
  enabled: PropTypes.bool.isRequired,
  itemType: PropTypes.oneOf([
    "documents",
    "images",
    "videos",
    "audios",
    "news",
    "assets",
  ]).isRequired,
  itemId: PropTypes.number.isRequired,
  assetPath: PropTypes.string,
  size: PropTypes.oneOf(["default", "compact", "large"]),
  hasBackground: PropTypes.bool,
};
